module.exports = __webpack_public_path__ + "images/05cd77ce41d62bc0db194b9462c82e1eb861047578097fd6082905a5f56569f7.svg";